var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartUpiIcons = function SvgCartUpiIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 26,
    fill: "none",
    viewBox: "0 0 59 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.5 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M19.5 11a8 8 0 1 0-16 0 8 8 0 0 0 16 0m1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BAF2",
    d: "M17.458 9.956a.8.8 0 0 0-.753-.535h-.008a.8.8 0 0 0-.576.246.8.8 0 0 0-.577-.246h-.007c-.199 0-.381.073-.521.193v-.06a.117.117 0 0 0-.117-.11h-.535a.12.12 0 0 0-.119.119v2.904c0 .065.053.118.119.118h.535c.06 0 .11-.045.116-.101v-2.085l.001-.02a.195.195 0 0 1 .185-.18h.098a.196.196 0 0 1 .185.2l.002 2.075c0 .065.053.119.118.119h.535c.064 0 .114-.05.117-.112v-2.083a.196.196 0 0 1 .186-.2h.098c.117.01.186.097.186.2l.002 2.072c0 .065.053.118.118.118h.535a.12.12 0 0 0 .118-.11v-2.273a.7.7 0 0 0-.04-.249m-3.62-.504h-.306v-.498a.11.11 0 0 0-.109-.107q-.01 0-.02.002c-.34.093-.272.562-.89.602h-.06l-.027.003a.12.12 0 0 0-.092.116v.536c0 .065.053.118.119.118h.322l-.001 2.267c0 .065.053.118.117.118h.53a.12.12 0 0 0 .117-.118v-2.267h.3a.12.12 0 0 0 .118-.118V9.57a.12.12 0 0 0-.119-.118"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#20336B",
    d: "M11.914 9.452h-.536a.12.12 0 0 0-.118.118v1.107a.125.125 0 0 1-.125.123h-.223a.126.126 0 0 1-.127-.125l-.001-1.105a.12.12 0 0 0-.119-.118h-.535a.12.12 0 0 0-.118.118v1.212c0 .46.328.79.79.79l.356.001c.062.007.11.06.11.124a.125.125 0 0 1-.11.124l-.008.002-.782.003a.12.12 0 0 0-.119.118v.535c0 .065.053.118.119.118h.874c.46 0 .789-.328.789-.788V9.57a.117.117 0 0 0-.117-.118m-3.043.003h-.743c-.065 0-.119.05-.119.11v.503c0 .064.057.118.126.118h.707c.056.008.1.05.107.113v.07a.12.12 0 0 1-.104.109h-.35c-.465 0-.796.31-.796.743v.622c0 .432.285.738.747.738h.97c.173 0 .315-.132.315-.294v-2.029c0-.492-.254-.803-.86-.803m.084 2.317-.001.02-.005.017a.125.125 0 0 1-.12.08h-.222c-.07 0-.126-.052-.126-.117v-.457c0-.065.056-.119.126-.119h.222c.07 0 .126.053.126.119zm-2.171-2.32h-1.17a.116.116 0 0 0-.116.116v2.906c0 .064.048.117.109.118h.545a.12.12 0 0 0 .118-.118l.002-.813h.512c.427 0 .726-.297.726-.727v-.754c0-.43-.299-.729-.726-.729m-.047 1.31c0 .07-.056.126-.125.126h-.34v-.661h.34c.069 0 .125.055.125.125z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F259F",
    d: "M31.5 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M31.5 11a8 8 0 1 0-16 0 8 8 0 0 0 16 0m1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.298 8.912a.59.59 0 0 0-.581-.581h-1.073l-2.458-2.816c-.223-.268-.58-.357-.939-.268l-.849.268c-.134.045-.178.224-.089.313l2.682 2.548h-4.067c-.135 0-.224.09-.224.223v.447c0 .313.268.581.581.581h.626v2.145c0 1.61.849 2.548 2.28 2.548.446 0 .803-.045 1.25-.224v1.43c0 .403.313.716.716.716h.625a.29.29 0 0 0 .268-.269v-6.39h1.028c.134 0 .224-.09.224-.224zm-2.86 3.844c-.269.134-.626.178-.894.178-.716 0-1.073-.357-1.073-1.162V9.627h1.967zM43.5 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M43.5 11a8 8 0 1 0-16 0 8 8 0 0 0 16 0m1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cart-upi-icons_svg__a)",
    d: "m35.821 12.06 2.97-5.144 1.617.934a2.18 2.18 0 0 1 .799 2.982l-1.674 2.896a1.367 1.367 0 0 1-1.864.502l-1.5-.867a.96.96 0 0 1-.348-1.304"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBD00",
    d: "m35.507 8.488-3.69 6.396 1.617.934a2.18 2.18 0 0 0 2.982-.798l2.395-4.15a1.363 1.363 0 0 0-.5-1.864l-1.504-.867a.95.95 0 0 0-1.3.349"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DA94F",
    d: "m38.79 6.916-1.142-.662a2.734 2.734 0 0 0-3.73.998l-2.123 3.678a1.363 1.363 0 0 0 .501 1.864l1.143.663a1.363 1.363 0 0 0 1.864-.502l2.536-4.391a1.904 1.904 0 0 1 2.603-.697"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cart-upi-icons_svg__b)",
    d: "m34.25 8.33-1.261-.726a1.177 1.177 0 0 0-1.606.43l-1.52 2.615a2.693 2.693 0 0 0 .99 3.683l2.127 1.223.505.293a2.07 2.07 0 0 1-.632-2.752l1.826-3.156a1.177 1.177 0 0 0-.43-1.61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.5 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M55.5 11a8 8 0 1 0-16 0 8 8 0 0 0 16 0m1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED752E",
    d: "m49.562 10.852-2.877-5.73-3.284 11.364z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#097939",
    d: "m51.6 10.852-2.878-5.73-3.284 11.364z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cart-upi-icons_svg__a",
    x1: 10.609,
    x2: 26.146,
    y1: 9.345,
    y2: 31.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cart-upi-icons_svg__b",
    x1: 4.196,
    x2: 17.605,
    y1: 10.108,
    y2: 22.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1B74E8"
  })))));
};
export default SvgCartUpiIcons;